"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monochrome = exports.grey = void 0;
var grey = {
  50: '#E4E4E4',
  100: '#BBBBBB',
  200: '#8D8D8D',
  300: '#5F5F5F',
  400: '#3D3D3D',
  500: '#1B1B1B',
  600: '#181818',
  700: '#141414',
  800: '#101010',
  900: '#080808'
};
exports.grey = grey;
var monochrome = {
  transparent: 'transparent',
  white: '#FFF',
  white_rgba: '255,255,255',
  superLight: '#F7F9FA',
  light: '#EEF1F5',
  medium: '#E4E8ED',
  mediumDark: '#7E8F9F',
  mediumDark_rgba: '126,143,159',
  dark: '#45525E',
  dark_rgba: '69,82,94',
  // so we can apply opacity
  superDark: '#36414D',
  black: grey['500'],
  black_rgba: '27,27,27'
};
exports.monochrome = monochrome;
//# sourceMappingURL=monochrome.js.map